import axios from "axios";

const B_URL = process.env.REACT_APP_LOGINURL;

const getAccountDeletionRequests = (
  sessionID,
  page,
  limit,
  status,
  accountType,
  search
) => {
  const payload = {
    functionName: "GetAccountDeletionRequests",
    postData: {
      offset: page,
      sort: { _id: -1 },
      limit,
      status,
      account_type: accountType,
      search,
    },
  };

  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };

  return axios.post(
    B_URL + "AccountDeletionModule/GetAccountDeletionRequests",
    payload,
    { headers }
  );
};

const updateAccountDeletionRequestStatus = (
  sessionID,
  requestId,
  status,
  adminNotes
) => {
  const payload = {
    functionName: "UpdateAccountDeletionRequestStatus",
    postData: {
      request_id: requestId,
      status,
      admin_notes: adminNotes,
    },
  };

  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };

  return axios.post(
    B_URL + "AccountDeletionModule/UpdateAccountDeletionRequestStatus",
    payload,
    { headers }
  );
};

const AccountDeletionService = {
  getAccountDeletionRequests,
  updateAccountDeletionRequestStatus,
};

export default AccountDeletionService;

